<form class="card mb-5" [formGroup]="form">
  <div class="container section-container">
    <div class="notification-rows">
      <div class="notification-row">
        <p class="notification-row-title">Mis fichajes</p>
        <div class="notification-row-control">
          <mat-form-field appearance="outline" class="nobottom notification-select">
            <mat-select formControlName="my_clock_notifications" [disabled]="fields_disabled()">
              @for (option of my_clock_notifications_options; track option) {
                <mat-option [value]="option">{{ my_clock_notifications_enum_labels[option] }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <p class="notification-row-description">{{ my_clock_notifications_description() }}</p>
        </div>
      </div>

      <div class="notification-row">
        <p class="notification-row-title">Fichajes de otros</p>
        <div class="notification-row-control">
          <mat-form-field appearance="outline" class="nobottom notification-select">
            <mat-select formControlName="others_clock_notifications" [disabled]="fields_disabled()">
              @for (option of others_clock_notifications_options; track option) {
                <mat-option [value]="option">{{ others_clock_notifications_enum_labels[option] }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <p class="notification-row-description">{{ others_clock_notifications_description() }}</p>
        </div>
      </div>
    </div>

    <button class="mb-4" mat-flat-button color="accent" type="button" (click)="save_notifications()" [disabled]="save_disabled()">
      <mat-icon>save</mat-icon>
      Guardar
    </button>
  </div>
</form>
